/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as DowngradeRouteImport } from './routes/downgrade'
import { Route as CancelSeedListPlanRouteImport } from './routes/cancelSeedListPlan'
import { Route as CancelPlanRouteImport } from './routes/cancelPlan'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as PrivateRouteImport } from './routes/_private'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PrivateTeamManagementRouteImport } from './routes/_private/team-management'
import { Route as PrivateRolesRouteImport } from './routes/_private/roles'
import { Route as PrivatePlansRouteImport } from './routes/_private/plans'
import { Route as PrivateLabelsRouteImport } from './routes/_private/labels'
import { Route as PrivateIntegrationRouteImport } from './routes/_private/integration'
import { Route as PrivateDashboardRouteImport } from './routes/_private/dashboard'
import { Route as AuthSigninRouteImport } from './routes/_auth/signin'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as PrivateTemplatesIndexRouteImport } from './routes/_private/templates/index'
import { Route as PrivateSeedListIndexRouteImport } from './routes/_private/seed-list/index'
import { Route as PrivatePostmasterIndexRouteImport } from './routes/_private/postmaster/index'
import { Route as PrivatePlacementTestIndexRouteImport } from './routes/_private/placement-test/index'
import { Route as PrivateMailboxesIndexRouteImport } from './routes/_private/mailboxes/index'
import { Route as PrivateDomainHealthIndexRouteImport } from './routes/_private/domain-health/index'
import { Route as PrivateBillingIndexRouteImport } from './routes/_private/billing/index'
import { Route as PrivateTemplatesEditorRouteImport } from './routes/_private/templates/editor'
import { Route as PrivateSeedListSeedCountsRouteImport } from './routes/_private/seed-list/seed-counts'
import { Route as PrivateSeedListSeedListRouteImport } from './routes/_private/seed-list/$seed-list'
import { Route as PrivatePostmasterPostmasterRouteImport } from './routes/_private/postmaster/$postmaster'
import { Route as PrivatePlacementTestPlacementTestRouteImport } from './routes/_private/placement-test/$placement-test'
import { Route as PrivateMailboxesWarmupAccountTabRouteImport } from './routes/_private/mailboxes/warmup-account-tab'
import { Route as PrivateMailboxesImportRouteImport } from './routes/_private/mailboxes/import'
import { Route as PrivateMailboxesDetailRouteImport } from './routes/_private/mailboxes/detail'
import { Route as PrivateMailboxesMailboxidRouteImport } from './routes/_private/mailboxes/$mailboxid'
import { Route as PrivateDomainHealthEmailHealthTestRouteImport } from './routes/_private/domain-health/email-health-test'
import { Route as PrivateBillingSuccessRouteImport } from './routes/_private/billing/success'
import { Route as PrivateBillingCancelRouteImport } from './routes/_private/billing/cancel'
import { Route as PrivatePostmasterTabsSpamTabRouteImport } from './routes/_private/postmaster/tabs/spam-tab'
import { Route as PrivatePostmasterTabsIpTabRouteImport } from './routes/_private/postmaster/tabs/ip-tab'
import { Route as PrivatePostmasterTabsFeedbackLoopTabRouteImport } from './routes/_private/postmaster/tabs/feedback-loop-tab'
import { Route as PrivatePostmasterTabsEncryptionTabRouteImport } from './routes/_private/postmaster/tabs/encryption-tab'
import { Route as PrivatePostmasterTabsDomainTabRouteImport } from './routes/_private/postmaster/tabs/domain-tab'
import { Route as PrivatePostmasterTabsDeliveryErrorTabRouteImport } from './routes/_private/postmaster/tabs/delivery-error-tab'
import { Route as PrivatePostmasterTabsAuthTabRouteImport } from './routes/_private/postmaster/tabs/auth-tab'
import { Route as PrivateDomainHealthDomainNameEspTypeRouteImport } from './routes/_private/domain-health/$domain-name/$esp-type'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DowngradeRoute = DowngradeRouteImport.update({
  id: '/downgrade',
  path: '/downgrade',
  getParentRoute: () => rootRouteImport,
} as any)
const CancelSeedListPlanRoute = CancelSeedListPlanRouteImport.update({
  id: '/cancelSeedListPlan',
  path: '/cancelSeedListPlan',
  getParentRoute: () => rootRouteImport,
} as any)
const CancelPlanRoute = CancelPlanRouteImport.update({
  id: '/cancelPlan',
  path: '/cancelPlan',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateRoute = PrivateRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateTeamManagementRoute = PrivateTeamManagementRouteImport.update({
  id: '/team-management',
  path: '/team-management',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateRolesRoute = PrivateRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivatePlansRoute = PrivatePlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateLabelsRoute = PrivateLabelsRouteImport.update({
  id: '/labels',
  path: '/labels',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateIntegrationRoute = PrivateIntegrationRouteImport.update({
  id: '/integration',
  path: '/integration',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateDashboardRoute = PrivateDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => PrivateRoute,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const PrivateTemplatesIndexRoute = PrivateTemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateSeedListIndexRoute = PrivateSeedListIndexRouteImport.update({
  id: '/seed-list/',
  path: '/seed-list/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivatePostmasterIndexRoute = PrivatePostmasterIndexRouteImport.update({
  id: '/postmaster/',
  path: '/postmaster/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivatePlacementTestIndexRoute =
  PrivatePlacementTestIndexRouteImport.update({
    id: '/placement-test/',
    path: '/placement-test/',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateMailboxesIndexRoute = PrivateMailboxesIndexRouteImport.update({
  id: '/mailboxes/',
  path: '/mailboxes/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateDomainHealthIndexRoute =
  PrivateDomainHealthIndexRouteImport.update({
    id: '/domain-health/',
    path: '/domain-health/',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateBillingIndexRoute = PrivateBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateTemplatesEditorRoute = PrivateTemplatesEditorRouteImport.update({
  id: '/templates/editor',
  path: '/templates/editor',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateSeedListSeedCountsRoute =
  PrivateSeedListSeedCountsRouteImport.update({
    id: '/seed-list/seed-counts',
    path: '/seed-list/seed-counts',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateSeedListSeedListRoute = PrivateSeedListSeedListRouteImport.update({
  id: '/seed-list/$seed-list',
  path: '/seed-list/$seed-list',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivatePostmasterPostmasterRoute =
  PrivatePostmasterPostmasterRouteImport.update({
    id: '/postmaster/$postmaster',
    path: '/postmaster/$postmaster',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivatePlacementTestPlacementTestRoute =
  PrivatePlacementTestPlacementTestRouteImport.update({
    id: '/placement-test/$placement-test',
    path: '/placement-test/$placement-test',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateMailboxesWarmupAccountTabRoute =
  PrivateMailboxesWarmupAccountTabRouteImport.update({
    id: '/mailboxes/warmup-account-tab',
    path: '/mailboxes/warmup-account-tab',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateMailboxesImportRoute = PrivateMailboxesImportRouteImport.update({
  id: '/mailboxes/import',
  path: '/mailboxes/import',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateMailboxesDetailRoute = PrivateMailboxesDetailRouteImport.update({
  id: '/mailboxes/detail',
  path: '/mailboxes/detail',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateMailboxesMailboxidRoute =
  PrivateMailboxesMailboxidRouteImport.update({
    id: '/mailboxes/$mailboxid',
    path: '/mailboxes/$mailboxid',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateDomainHealthEmailHealthTestRoute =
  PrivateDomainHealthEmailHealthTestRouteImport.update({
    id: '/domain-health/email-health-test',
    path: '/domain-health/email-health-test',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateBillingSuccessRoute = PrivateBillingSuccessRouteImport.update({
  id: '/billing/success',
  path: '/billing/success',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateBillingCancelRoute = PrivateBillingCancelRouteImport.update({
  id: '/billing/cancel',
  path: '/billing/cancel',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivatePostmasterTabsSpamTabRoute =
  PrivatePostmasterTabsSpamTabRouteImport.update({
    id: '/postmaster/tabs/spam-tab',
    path: '/postmaster/tabs/spam-tab',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivatePostmasterTabsIpTabRoute =
  PrivatePostmasterTabsIpTabRouteImport.update({
    id: '/postmaster/tabs/ip-tab',
    path: '/postmaster/tabs/ip-tab',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivatePostmasterTabsFeedbackLoopTabRoute =
  PrivatePostmasterTabsFeedbackLoopTabRouteImport.update({
    id: '/postmaster/tabs/feedback-loop-tab',
    path: '/postmaster/tabs/feedback-loop-tab',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivatePostmasterTabsEncryptionTabRoute =
  PrivatePostmasterTabsEncryptionTabRouteImport.update({
    id: '/postmaster/tabs/encryption-tab',
    path: '/postmaster/tabs/encryption-tab',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivatePostmasterTabsDomainTabRoute =
  PrivatePostmasterTabsDomainTabRouteImport.update({
    id: '/postmaster/tabs/domain-tab',
    path: '/postmaster/tabs/domain-tab',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivatePostmasterTabsDeliveryErrorTabRoute =
  PrivatePostmasterTabsDeliveryErrorTabRouteImport.update({
    id: '/postmaster/tabs/delivery-error-tab',
    path: '/postmaster/tabs/delivery-error-tab',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivatePostmasterTabsAuthTabRoute =
  PrivatePostmasterTabsAuthTabRouteImport.update({
    id: '/postmaster/tabs/auth-tab',
    path: '/postmaster/tabs/auth-tab',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateDomainHealthDomainNameEspTypeRoute =
  PrivateDomainHealthDomainNameEspTypeRouteImport.update({
    id: '/domain-health/$domain-name/$esp-type',
    path: '/domain-health/$domain-name/$esp-type',
    getParentRoute: () => PrivateRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/cancelPlan': typeof CancelPlanRoute
  '/cancelSeedListPlan': typeof CancelSeedListPlanRoute
  '/downgrade': typeof DowngradeRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-up': typeof AuthSignUpRoute
  '/signin': typeof AuthSigninRoute
  '/dashboard': typeof PrivateDashboardRoute
  '/integration': typeof PrivateIntegrationRoute
  '/labels': typeof PrivateLabelsRoute
  '/plans': typeof PrivatePlansRoute
  '/roles': typeof PrivateRolesRoute
  '/team-management': typeof PrivateTeamManagementRoute
  '/billing/cancel': typeof PrivateBillingCancelRoute
  '/billing/success': typeof PrivateBillingSuccessRoute
  '/domain-health/email-health-test': typeof PrivateDomainHealthEmailHealthTestRoute
  '/mailboxes/$mailboxid': typeof PrivateMailboxesMailboxidRoute
  '/mailboxes/detail': typeof PrivateMailboxesDetailRoute
  '/mailboxes/import': typeof PrivateMailboxesImportRoute
  '/mailboxes/warmup-account-tab': typeof PrivateMailboxesWarmupAccountTabRoute
  '/placement-test/$placement-test': typeof PrivatePlacementTestPlacementTestRoute
  '/postmaster/$postmaster': typeof PrivatePostmasterPostmasterRoute
  '/seed-list/$seed-list': typeof PrivateSeedListSeedListRoute
  '/seed-list/seed-counts': typeof PrivateSeedListSeedCountsRoute
  '/templates/editor': typeof PrivateTemplatesEditorRoute
  '/billing': typeof PrivateBillingIndexRoute
  '/domain-health': typeof PrivateDomainHealthIndexRoute
  '/mailboxes': typeof PrivateMailboxesIndexRoute
  '/placement-test': typeof PrivatePlacementTestIndexRoute
  '/postmaster': typeof PrivatePostmasterIndexRoute
  '/seed-list': typeof PrivateSeedListIndexRoute
  '/templates': typeof PrivateTemplatesIndexRoute
  '/domain-health/$domain-name/$esp-type': typeof PrivateDomainHealthDomainNameEspTypeRoute
  '/postmaster/tabs/auth-tab': typeof PrivatePostmasterTabsAuthTabRoute
  '/postmaster/tabs/delivery-error-tab': typeof PrivatePostmasterTabsDeliveryErrorTabRoute
  '/postmaster/tabs/domain-tab': typeof PrivatePostmasterTabsDomainTabRoute
  '/postmaster/tabs/encryption-tab': typeof PrivatePostmasterTabsEncryptionTabRoute
  '/postmaster/tabs/feedback-loop-tab': typeof PrivatePostmasterTabsFeedbackLoopTabRoute
  '/postmaster/tabs/ip-tab': typeof PrivatePostmasterTabsIpTabRoute
  '/postmaster/tabs/spam-tab': typeof PrivatePostmasterTabsSpamTabRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cancelPlan': typeof CancelPlanRoute
  '/cancelSeedListPlan': typeof CancelSeedListPlanRoute
  '/downgrade': typeof DowngradeRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-up': typeof AuthSignUpRoute
  '/signin': typeof AuthSigninRoute
  '/dashboard': typeof PrivateDashboardRoute
  '/integration': typeof PrivateIntegrationRoute
  '/labels': typeof PrivateLabelsRoute
  '/plans': typeof PrivatePlansRoute
  '/roles': typeof PrivateRolesRoute
  '/team-management': typeof PrivateTeamManagementRoute
  '/billing/cancel': typeof PrivateBillingCancelRoute
  '/billing/success': typeof PrivateBillingSuccessRoute
  '/domain-health/email-health-test': typeof PrivateDomainHealthEmailHealthTestRoute
  '/mailboxes/$mailboxid': typeof PrivateMailboxesMailboxidRoute
  '/mailboxes/detail': typeof PrivateMailboxesDetailRoute
  '/mailboxes/import': typeof PrivateMailboxesImportRoute
  '/mailboxes/warmup-account-tab': typeof PrivateMailboxesWarmupAccountTabRoute
  '/placement-test/$placement-test': typeof PrivatePlacementTestPlacementTestRoute
  '/postmaster/$postmaster': typeof PrivatePostmasterPostmasterRoute
  '/seed-list/$seed-list': typeof PrivateSeedListSeedListRoute
  '/seed-list/seed-counts': typeof PrivateSeedListSeedCountsRoute
  '/templates/editor': typeof PrivateTemplatesEditorRoute
  '/billing': typeof PrivateBillingIndexRoute
  '/domain-health': typeof PrivateDomainHealthIndexRoute
  '/mailboxes': typeof PrivateMailboxesIndexRoute
  '/placement-test': typeof PrivatePlacementTestIndexRoute
  '/postmaster': typeof PrivatePostmasterIndexRoute
  '/seed-list': typeof PrivateSeedListIndexRoute
  '/templates': typeof PrivateTemplatesIndexRoute
  '/domain-health/$domain-name/$esp-type': typeof PrivateDomainHealthDomainNameEspTypeRoute
  '/postmaster/tabs/auth-tab': typeof PrivatePostmasterTabsAuthTabRoute
  '/postmaster/tabs/delivery-error-tab': typeof PrivatePostmasterTabsDeliveryErrorTabRoute
  '/postmaster/tabs/domain-tab': typeof PrivatePostmasterTabsDomainTabRoute
  '/postmaster/tabs/encryption-tab': typeof PrivatePostmasterTabsEncryptionTabRoute
  '/postmaster/tabs/feedback-loop-tab': typeof PrivatePostmasterTabsFeedbackLoopTabRoute
  '/postmaster/tabs/ip-tab': typeof PrivatePostmasterTabsIpTabRoute
  '/postmaster/tabs/spam-tab': typeof PrivatePostmasterTabsSpamTabRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_private': typeof PrivateRouteWithChildren
  '/_public': typeof PublicRoute
  '/cancelPlan': typeof CancelPlanRoute
  '/cancelSeedListPlan': typeof CancelSeedListPlanRoute
  '/downgrade': typeof DowngradeRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/_auth/signin': typeof AuthSigninRoute
  '/_private/dashboard': typeof PrivateDashboardRoute
  '/_private/integration': typeof PrivateIntegrationRoute
  '/_private/labels': typeof PrivateLabelsRoute
  '/_private/plans': typeof PrivatePlansRoute
  '/_private/roles': typeof PrivateRolesRoute
  '/_private/team-management': typeof PrivateTeamManagementRoute
  '/_private/billing/cancel': typeof PrivateBillingCancelRoute
  '/_private/billing/success': typeof PrivateBillingSuccessRoute
  '/_private/domain-health/email-health-test': typeof PrivateDomainHealthEmailHealthTestRoute
  '/_private/mailboxes/$mailboxid': typeof PrivateMailboxesMailboxidRoute
  '/_private/mailboxes/detail': typeof PrivateMailboxesDetailRoute
  '/_private/mailboxes/import': typeof PrivateMailboxesImportRoute
  '/_private/mailboxes/warmup-account-tab': typeof PrivateMailboxesWarmupAccountTabRoute
  '/_private/placement-test/$placement-test': typeof PrivatePlacementTestPlacementTestRoute
  '/_private/postmaster/$postmaster': typeof PrivatePostmasterPostmasterRoute
  '/_private/seed-list/$seed-list': typeof PrivateSeedListSeedListRoute
  '/_private/seed-list/seed-counts': typeof PrivateSeedListSeedCountsRoute
  '/_private/templates/editor': typeof PrivateTemplatesEditorRoute
  '/_private/billing/': typeof PrivateBillingIndexRoute
  '/_private/domain-health/': typeof PrivateDomainHealthIndexRoute
  '/_private/mailboxes/': typeof PrivateMailboxesIndexRoute
  '/_private/placement-test/': typeof PrivatePlacementTestIndexRoute
  '/_private/postmaster/': typeof PrivatePostmasterIndexRoute
  '/_private/seed-list/': typeof PrivateSeedListIndexRoute
  '/_private/templates/': typeof PrivateTemplatesIndexRoute
  '/_private/domain-health/$domain-name/$esp-type': typeof PrivateDomainHealthDomainNameEspTypeRoute
  '/_private/postmaster/tabs/auth-tab': typeof PrivatePostmasterTabsAuthTabRoute
  '/_private/postmaster/tabs/delivery-error-tab': typeof PrivatePostmasterTabsDeliveryErrorTabRoute
  '/_private/postmaster/tabs/domain-tab': typeof PrivatePostmasterTabsDomainTabRoute
  '/_private/postmaster/tabs/encryption-tab': typeof PrivatePostmasterTabsEncryptionTabRoute
  '/_private/postmaster/tabs/feedback-loop-tab': typeof PrivatePostmasterTabsFeedbackLoopTabRoute
  '/_private/postmaster/tabs/ip-tab': typeof PrivatePostmasterTabsIpTabRoute
  '/_private/postmaster/tabs/spam-tab': typeof PrivatePostmasterTabsSpamTabRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cancelPlan'
    | '/cancelSeedListPlan'
    | '/downgrade'
    | '/reset-password'
    | '/sign-up'
    | '/signin'
    | '/dashboard'
    | '/integration'
    | '/labels'
    | '/plans'
    | '/roles'
    | '/team-management'
    | '/billing/cancel'
    | '/billing/success'
    | '/domain-health/email-health-test'
    | '/mailboxes/$mailboxid'
    | '/mailboxes/detail'
    | '/mailboxes/import'
    | '/mailboxes/warmup-account-tab'
    | '/placement-test/$placement-test'
    | '/postmaster/$postmaster'
    | '/seed-list/$seed-list'
    | '/seed-list/seed-counts'
    | '/templates/editor'
    | '/billing'
    | '/domain-health'
    | '/mailboxes'
    | '/placement-test'
    | '/postmaster'
    | '/seed-list'
    | '/templates'
    | '/domain-health/$domain-name/$esp-type'
    | '/postmaster/tabs/auth-tab'
    | '/postmaster/tabs/delivery-error-tab'
    | '/postmaster/tabs/domain-tab'
    | '/postmaster/tabs/encryption-tab'
    | '/postmaster/tabs/feedback-loop-tab'
    | '/postmaster/tabs/ip-tab'
    | '/postmaster/tabs/spam-tab'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cancelPlan'
    | '/cancelSeedListPlan'
    | '/downgrade'
    | '/reset-password'
    | '/sign-up'
    | '/signin'
    | '/dashboard'
    | '/integration'
    | '/labels'
    | '/plans'
    | '/roles'
    | '/team-management'
    | '/billing/cancel'
    | '/billing/success'
    | '/domain-health/email-health-test'
    | '/mailboxes/$mailboxid'
    | '/mailboxes/detail'
    | '/mailboxes/import'
    | '/mailboxes/warmup-account-tab'
    | '/placement-test/$placement-test'
    | '/postmaster/$postmaster'
    | '/seed-list/$seed-list'
    | '/seed-list/seed-counts'
    | '/templates/editor'
    | '/billing'
    | '/domain-health'
    | '/mailboxes'
    | '/placement-test'
    | '/postmaster'
    | '/seed-list'
    | '/templates'
    | '/domain-health/$domain-name/$esp-type'
    | '/postmaster/tabs/auth-tab'
    | '/postmaster/tabs/delivery-error-tab'
    | '/postmaster/tabs/domain-tab'
    | '/postmaster/tabs/encryption-tab'
    | '/postmaster/tabs/feedback-loop-tab'
    | '/postmaster/tabs/ip-tab'
    | '/postmaster/tabs/spam-tab'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_private'
    | '/_public'
    | '/cancelPlan'
    | '/cancelSeedListPlan'
    | '/downgrade'
    | '/reset-password'
    | '/_auth/sign-up'
    | '/_auth/signin'
    | '/_private/dashboard'
    | '/_private/integration'
    | '/_private/labels'
    | '/_private/plans'
    | '/_private/roles'
    | '/_private/team-management'
    | '/_private/billing/cancel'
    | '/_private/billing/success'
    | '/_private/domain-health/email-health-test'
    | '/_private/mailboxes/$mailboxid'
    | '/_private/mailboxes/detail'
    | '/_private/mailboxes/import'
    | '/_private/mailboxes/warmup-account-tab'
    | '/_private/placement-test/$placement-test'
    | '/_private/postmaster/$postmaster'
    | '/_private/seed-list/$seed-list'
    | '/_private/seed-list/seed-counts'
    | '/_private/templates/editor'
    | '/_private/billing/'
    | '/_private/domain-health/'
    | '/_private/mailboxes/'
    | '/_private/placement-test/'
    | '/_private/postmaster/'
    | '/_private/seed-list/'
    | '/_private/templates/'
    | '/_private/domain-health/$domain-name/$esp-type'
    | '/_private/postmaster/tabs/auth-tab'
    | '/_private/postmaster/tabs/delivery-error-tab'
    | '/_private/postmaster/tabs/domain-tab'
    | '/_private/postmaster/tabs/encryption-tab'
    | '/_private/postmaster/tabs/feedback-loop-tab'
    | '/_private/postmaster/tabs/ip-tab'
    | '/_private/postmaster/tabs/spam-tab'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  PrivateRoute: typeof PrivateRouteWithChildren
  PublicRoute: typeof PublicRoute
  CancelPlanRoute: typeof CancelPlanRoute
  CancelSeedListPlanRoute: typeof CancelSeedListPlanRoute
  DowngradeRoute: typeof DowngradeRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/downgrade': {
      id: '/downgrade'
      path: '/downgrade'
      fullPath: '/downgrade'
      preLoaderRoute: typeof DowngradeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cancelSeedListPlan': {
      id: '/cancelSeedListPlan'
      path: '/cancelSeedListPlan'
      fullPath: '/cancelSeedListPlan'
      preLoaderRoute: typeof CancelSeedListPlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cancelPlan': {
      id: '/cancelPlan'
      path: '/cancelPlan'
      fullPath: '/cancelPlan'
      preLoaderRoute: typeof CancelPlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private/team-management': {
      id: '/_private/team-management'
      path: '/team-management'
      fullPath: '/team-management'
      preLoaderRoute: typeof PrivateTeamManagementRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/roles': {
      id: '/_private/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof PrivateRolesRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/plans': {
      id: '/_private/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof PrivatePlansRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/labels': {
      id: '/_private/labels'
      path: '/labels'
      fullPath: '/labels'
      preLoaderRoute: typeof PrivateLabelsRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/integration': {
      id: '/_private/integration'
      path: '/integration'
      fullPath: '/integration'
      preLoaderRoute: typeof PrivateIntegrationRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/dashboard': {
      id: '/_private/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof PrivateDashboardRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_auth/signin': {
      id: '/_auth/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_private/templates/': {
      id: '/_private/templates/'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof PrivateTemplatesIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/seed-list/': {
      id: '/_private/seed-list/'
      path: '/seed-list'
      fullPath: '/seed-list'
      preLoaderRoute: typeof PrivateSeedListIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/postmaster/': {
      id: '/_private/postmaster/'
      path: '/postmaster'
      fullPath: '/postmaster'
      preLoaderRoute: typeof PrivatePostmasterIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/placement-test/': {
      id: '/_private/placement-test/'
      path: '/placement-test'
      fullPath: '/placement-test'
      preLoaderRoute: typeof PrivatePlacementTestIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/mailboxes/': {
      id: '/_private/mailboxes/'
      path: '/mailboxes'
      fullPath: '/mailboxes'
      preLoaderRoute: typeof PrivateMailboxesIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/domain-health/': {
      id: '/_private/domain-health/'
      path: '/domain-health'
      fullPath: '/domain-health'
      preLoaderRoute: typeof PrivateDomainHealthIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/billing/': {
      id: '/_private/billing/'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof PrivateBillingIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/templates/editor': {
      id: '/_private/templates/editor'
      path: '/templates/editor'
      fullPath: '/templates/editor'
      preLoaderRoute: typeof PrivateTemplatesEditorRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/seed-list/seed-counts': {
      id: '/_private/seed-list/seed-counts'
      path: '/seed-list/seed-counts'
      fullPath: '/seed-list/seed-counts'
      preLoaderRoute: typeof PrivateSeedListSeedCountsRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/seed-list/$seed-list': {
      id: '/_private/seed-list/$seed-list'
      path: '/seed-list/$seed-list'
      fullPath: '/seed-list/$seed-list'
      preLoaderRoute: typeof PrivateSeedListSeedListRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/postmaster/$postmaster': {
      id: '/_private/postmaster/$postmaster'
      path: '/postmaster/$postmaster'
      fullPath: '/postmaster/$postmaster'
      preLoaderRoute: typeof PrivatePostmasterPostmasterRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/placement-test/$placement-test': {
      id: '/_private/placement-test/$placement-test'
      path: '/placement-test/$placement-test'
      fullPath: '/placement-test/$placement-test'
      preLoaderRoute: typeof PrivatePlacementTestPlacementTestRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/mailboxes/warmup-account-tab': {
      id: '/_private/mailboxes/warmup-account-tab'
      path: '/mailboxes/warmup-account-tab'
      fullPath: '/mailboxes/warmup-account-tab'
      preLoaderRoute: typeof PrivateMailboxesWarmupAccountTabRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/mailboxes/import': {
      id: '/_private/mailboxes/import'
      path: '/mailboxes/import'
      fullPath: '/mailboxes/import'
      preLoaderRoute: typeof PrivateMailboxesImportRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/mailboxes/detail': {
      id: '/_private/mailboxes/detail'
      path: '/mailboxes/detail'
      fullPath: '/mailboxes/detail'
      preLoaderRoute: typeof PrivateMailboxesDetailRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/mailboxes/$mailboxid': {
      id: '/_private/mailboxes/$mailboxid'
      path: '/mailboxes/$mailboxid'
      fullPath: '/mailboxes/$mailboxid'
      preLoaderRoute: typeof PrivateMailboxesMailboxidRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/domain-health/email-health-test': {
      id: '/_private/domain-health/email-health-test'
      path: '/domain-health/email-health-test'
      fullPath: '/domain-health/email-health-test'
      preLoaderRoute: typeof PrivateDomainHealthEmailHealthTestRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/billing/success': {
      id: '/_private/billing/success'
      path: '/billing/success'
      fullPath: '/billing/success'
      preLoaderRoute: typeof PrivateBillingSuccessRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/billing/cancel': {
      id: '/_private/billing/cancel'
      path: '/billing/cancel'
      fullPath: '/billing/cancel'
      preLoaderRoute: typeof PrivateBillingCancelRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/postmaster/tabs/spam-tab': {
      id: '/_private/postmaster/tabs/spam-tab'
      path: '/postmaster/tabs/spam-tab'
      fullPath: '/postmaster/tabs/spam-tab'
      preLoaderRoute: typeof PrivatePostmasterTabsSpamTabRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/postmaster/tabs/ip-tab': {
      id: '/_private/postmaster/tabs/ip-tab'
      path: '/postmaster/tabs/ip-tab'
      fullPath: '/postmaster/tabs/ip-tab'
      preLoaderRoute: typeof PrivatePostmasterTabsIpTabRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/postmaster/tabs/feedback-loop-tab': {
      id: '/_private/postmaster/tabs/feedback-loop-tab'
      path: '/postmaster/tabs/feedback-loop-tab'
      fullPath: '/postmaster/tabs/feedback-loop-tab'
      preLoaderRoute: typeof PrivatePostmasterTabsFeedbackLoopTabRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/postmaster/tabs/encryption-tab': {
      id: '/_private/postmaster/tabs/encryption-tab'
      path: '/postmaster/tabs/encryption-tab'
      fullPath: '/postmaster/tabs/encryption-tab'
      preLoaderRoute: typeof PrivatePostmasterTabsEncryptionTabRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/postmaster/tabs/domain-tab': {
      id: '/_private/postmaster/tabs/domain-tab'
      path: '/postmaster/tabs/domain-tab'
      fullPath: '/postmaster/tabs/domain-tab'
      preLoaderRoute: typeof PrivatePostmasterTabsDomainTabRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/postmaster/tabs/delivery-error-tab': {
      id: '/_private/postmaster/tabs/delivery-error-tab'
      path: '/postmaster/tabs/delivery-error-tab'
      fullPath: '/postmaster/tabs/delivery-error-tab'
      preLoaderRoute: typeof PrivatePostmasterTabsDeliveryErrorTabRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/postmaster/tabs/auth-tab': {
      id: '/_private/postmaster/tabs/auth-tab'
      path: '/postmaster/tabs/auth-tab'
      fullPath: '/postmaster/tabs/auth-tab'
      preLoaderRoute: typeof PrivatePostmasterTabsAuthTabRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/domain-health/$domain-name/$esp-type': {
      id: '/_private/domain-health/$domain-name/$esp-type'
      path: '/domain-health/$domain-name/$esp-type'
      fullPath: '/domain-health/$domain-name/$esp-type'
      preLoaderRoute: typeof PrivateDomainHealthDomainNameEspTypeRouteImport
      parentRoute: typeof PrivateRoute
    }
  }
}

interface AuthRouteChildren {
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthSigninRoute: typeof AuthSigninRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSignUpRoute: AuthSignUpRoute,
  AuthSigninRoute: AuthSigninRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PrivateRouteChildren {
  PrivateDashboardRoute: typeof PrivateDashboardRoute
  PrivateIntegrationRoute: typeof PrivateIntegrationRoute
  PrivateLabelsRoute: typeof PrivateLabelsRoute
  PrivatePlansRoute: typeof PrivatePlansRoute
  PrivateRolesRoute: typeof PrivateRolesRoute
  PrivateTeamManagementRoute: typeof PrivateTeamManagementRoute
  PrivateBillingCancelRoute: typeof PrivateBillingCancelRoute
  PrivateBillingSuccessRoute: typeof PrivateBillingSuccessRoute
  PrivateDomainHealthEmailHealthTestRoute: typeof PrivateDomainHealthEmailHealthTestRoute
  PrivateMailboxesMailboxidRoute: typeof PrivateMailboxesMailboxidRoute
  PrivateMailboxesDetailRoute: typeof PrivateMailboxesDetailRoute
  PrivateMailboxesImportRoute: typeof PrivateMailboxesImportRoute
  PrivateMailboxesWarmupAccountTabRoute: typeof PrivateMailboxesWarmupAccountTabRoute
  PrivatePlacementTestPlacementTestRoute: typeof PrivatePlacementTestPlacementTestRoute
  PrivatePostmasterPostmasterRoute: typeof PrivatePostmasterPostmasterRoute
  PrivateSeedListSeedListRoute: typeof PrivateSeedListSeedListRoute
  PrivateSeedListSeedCountsRoute: typeof PrivateSeedListSeedCountsRoute
  PrivateTemplatesEditorRoute: typeof PrivateTemplatesEditorRoute
  PrivateBillingIndexRoute: typeof PrivateBillingIndexRoute
  PrivateDomainHealthIndexRoute: typeof PrivateDomainHealthIndexRoute
  PrivateMailboxesIndexRoute: typeof PrivateMailboxesIndexRoute
  PrivatePlacementTestIndexRoute: typeof PrivatePlacementTestIndexRoute
  PrivatePostmasterIndexRoute: typeof PrivatePostmasterIndexRoute
  PrivateSeedListIndexRoute: typeof PrivateSeedListIndexRoute
  PrivateTemplatesIndexRoute: typeof PrivateTemplatesIndexRoute
  PrivateDomainHealthDomainNameEspTypeRoute: typeof PrivateDomainHealthDomainNameEspTypeRoute
  PrivatePostmasterTabsAuthTabRoute: typeof PrivatePostmasterTabsAuthTabRoute
  PrivatePostmasterTabsDeliveryErrorTabRoute: typeof PrivatePostmasterTabsDeliveryErrorTabRoute
  PrivatePostmasterTabsDomainTabRoute: typeof PrivatePostmasterTabsDomainTabRoute
  PrivatePostmasterTabsEncryptionTabRoute: typeof PrivatePostmasterTabsEncryptionTabRoute
  PrivatePostmasterTabsFeedbackLoopTabRoute: typeof PrivatePostmasterTabsFeedbackLoopTabRoute
  PrivatePostmasterTabsIpTabRoute: typeof PrivatePostmasterTabsIpTabRoute
  PrivatePostmasterTabsSpamTabRoute: typeof PrivatePostmasterTabsSpamTabRoute
}

const PrivateRouteChildren: PrivateRouteChildren = {
  PrivateDashboardRoute: PrivateDashboardRoute,
  PrivateIntegrationRoute: PrivateIntegrationRoute,
  PrivateLabelsRoute: PrivateLabelsRoute,
  PrivatePlansRoute: PrivatePlansRoute,
  PrivateRolesRoute: PrivateRolesRoute,
  PrivateTeamManagementRoute: PrivateTeamManagementRoute,
  PrivateBillingCancelRoute: PrivateBillingCancelRoute,
  PrivateBillingSuccessRoute: PrivateBillingSuccessRoute,
  PrivateDomainHealthEmailHealthTestRoute:
    PrivateDomainHealthEmailHealthTestRoute,
  PrivateMailboxesMailboxidRoute: PrivateMailboxesMailboxidRoute,
  PrivateMailboxesDetailRoute: PrivateMailboxesDetailRoute,
  PrivateMailboxesImportRoute: PrivateMailboxesImportRoute,
  PrivateMailboxesWarmupAccountTabRoute: PrivateMailboxesWarmupAccountTabRoute,
  PrivatePlacementTestPlacementTestRoute:
    PrivatePlacementTestPlacementTestRoute,
  PrivatePostmasterPostmasterRoute: PrivatePostmasterPostmasterRoute,
  PrivateSeedListSeedListRoute: PrivateSeedListSeedListRoute,
  PrivateSeedListSeedCountsRoute: PrivateSeedListSeedCountsRoute,
  PrivateTemplatesEditorRoute: PrivateTemplatesEditorRoute,
  PrivateBillingIndexRoute: PrivateBillingIndexRoute,
  PrivateDomainHealthIndexRoute: PrivateDomainHealthIndexRoute,
  PrivateMailboxesIndexRoute: PrivateMailboxesIndexRoute,
  PrivatePlacementTestIndexRoute: PrivatePlacementTestIndexRoute,
  PrivatePostmasterIndexRoute: PrivatePostmasterIndexRoute,
  PrivateSeedListIndexRoute: PrivateSeedListIndexRoute,
  PrivateTemplatesIndexRoute: PrivateTemplatesIndexRoute,
  PrivateDomainHealthDomainNameEspTypeRoute:
    PrivateDomainHealthDomainNameEspTypeRoute,
  PrivatePostmasterTabsAuthTabRoute: PrivatePostmasterTabsAuthTabRoute,
  PrivatePostmasterTabsDeliveryErrorTabRoute:
    PrivatePostmasterTabsDeliveryErrorTabRoute,
  PrivatePostmasterTabsDomainTabRoute: PrivatePostmasterTabsDomainTabRoute,
  PrivatePostmasterTabsEncryptionTabRoute:
    PrivatePostmasterTabsEncryptionTabRoute,
  PrivatePostmasterTabsFeedbackLoopTabRoute:
    PrivatePostmasterTabsFeedbackLoopTabRoute,
  PrivatePostmasterTabsIpTabRoute: PrivatePostmasterTabsIpTabRoute,
  PrivatePostmasterTabsSpamTabRoute: PrivatePostmasterTabsSpamTabRoute,
}

const PrivateRouteWithChildren =
  PrivateRoute._addFileChildren(PrivateRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  PrivateRoute: PrivateRouteWithChildren,
  PublicRoute: PublicRoute,
  CancelPlanRoute: CancelPlanRoute,
  CancelSeedListPlanRoute: CancelSeedListPlanRoute,
  DowngradeRoute: DowngradeRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
